import * as types from "./types";
import _ from 'lodash';

export const defaultState = {
  usage_logs: {},
  loading: false,
  errors: []   
};

const usage_logs = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHED_USAGE_LOGS:   
      return {
        ...state,
        usage_logs: {...state.usage_logs, [action.productId]: [...action.usage_logs]},
        loading: action.loading        
      }     
    case types.ADDED_USAGE_LOG:    
      return {
        ...state,
        usage_logs: {...state.usage_logs, [action.usage_log.product_guid]: [...state.usage_logs[action.usage_log.product_guid], action.usage_log]},
        loading: action.loading        
    }    
    case types.DELETED_USAGE_LOG:
      let current_logs = {...state.usage_logs};
      _.remove(current_logs[action.usage_log.product_guid], {guid: action.usage_log.guid});
      return{
        ...state,
        usage_logs: {...current_logs},
        loading: action.loading 
      }   
    case types.FETCHING_USAGE_LOGS:       
    case types.DELETING_USAGE_LOG:       
    case types.ADDING_USAGE_LOG:       
      return {
        ...state,
        loading: action.loading
      }     
    case types.ERROR_FETCHING_USAGE_LOGS:        
    case types.ERROR_DELETING_USAGE_LOG:        
    case types.ERROR_ADD_USAGE_LOG:        
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      }
    default:
      return state;
  }
};
export default usage_logs;
